import { Badge } from '../../Badge/Badge'
import { formatDate } from '../../../helpers/formatDate'
import type { ColumnDef } from '../../DataTable/DataTable'
import type { TenantDTO, TenantGroupDTO } from '../../../types'

export function buildTenantsTableColumns(
  tenantGroups: TenantGroupDTO[]
): ColumnDef<TenantDTO>[] {
  const groupById = new Map(tenantGroups.map((g) => [g.id, g]))

  return [
    {
      header: 'ID',
      sortValue: (t) => t.id,
      accessor: (t) => t.id,
      className: 'table-id-col text-end',
      cellClassName: 'font-monospace small',
    },
    {
      header: 'Code',
      sortValue: (t) => t.code,
      accessor: (t) => t.code,
      cellClassName: 'fw-medium',
    },
    {
      header: 'Name',
      sortValue: (t) => t.name,
      accessor: (t) => t.name,
    },
    {
      header: 'Tenant Group',
      sortValue: (t) => groupById.get(t.tenantGroupId)?.code ?? t.tenantGroupId,
      accessor: (t) => {
        const code = groupById.get(t.tenantGroupId)?.code ?? t.tenantGroupId
        return <Badge color="grey">{code}</Badge>
      },
    },
    {
      header: 'Created',
      sortValue: (t) => t.createdAt,
      accessor: (t) => formatDate(t.createdAt),
    },
    {
      header: 'Updated',
      sortValue: (t) => t.updatedAt,
      accessor: (t) => formatDate(t.updatedAt),
    },
  ]
}
